import {Order} from './Order';
import { OrderItemProduct } from './OrderItemProduct';
import {ServiceSubjectItem} from './ServiceSubjectItem';
import {FileManager} from '../../shared/Models/FileManager';

export class ServiceRequest {

  /**
   * ServiceRequest Types
   */
  static SERVICE_TYPE = {key: 'service', value: 'Service'};
  static REMARK_TYPE = {key: 'remark', value: 'Remark'};


  /**
   * ServiceRequest Properties
   */
  public id: number;
  public order?: Order;
  public serviceNumber?: string;
  public orderItemProducts?: OrderItemProduct[];
  public createdAt?: string;
  public type?: string;
  public subject?: string;
  public serviceSubject?: any;
  public subjectTitle?: string;
  public serviceSubjectItems?: ServiceSubjectItem[];
  public reply?: any;
  public canceledReplies?: Array<any>;
  public isRemark?: boolean;
  public message?: string;
  public phone?: string;
  public files?: FileManager[];
  public status?: any;
  public priority?: any;
  public outOfWarranty?: boolean;
  public user?: any;
  public isArchived?: boolean;
}
